// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'vodafoneFont', 'vodafoneFont Fallback'"},"className":"__className_f8b896"};